module.exports = __webpack_public_path__ + "img/alipay.ca1dcb6d.png";